var _style, _g, _defs, _polygon, _defs2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalciumDeficiency({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#315CA6;}\n\t.st1{opacity:0;clip-path:url(#SVGID_2_);fill:#FFFFFF;enable-background:new    ;}\n\t.st2{clip-path:url(#SVGID_4_);}\n\t.st3{fill:#F8EEE1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 S62.9,180.3,105.7,180.3"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 S62.9,180.3,105.7,180.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "28.2,107.7 183.3,107.7 192.6,154.3 151.7,191.3 105.7,200.6 22.8,190.3 22.8,124.4  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 S62.9,180.3,105.7,180.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M116,96.4c-0.7-1.8-1.2-3.7-1.5-5.6c-0.1-0.7-0.2-1.3-0.3-2.1c-0.7-4.3-0.1-8.8,1.6-12.8 c8-18.1,26.2-68.1,26.2-68.1l-18-4.5l-29.9,66c-1,2.2-2.1,4.4-3.3,6.6c-1.2,2.1-3.1,6-4.8,11.9c-2.5,17.4,10,18.1,15.5,19.3 c3.4,0.7,6.4-0.1,8.2-0.8c0.3-0.1,0.6-0.3,0.9-0.4l0,0c0,0,7.2-3.4,5.6-8.7C116.2,96.8,116.1,96.6,116,96.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84,100.7c-0.6-1.4-3.4-7.3-0.3-16.1c0.7-1.9,0.4-2.2-0.4-1.7c0,0,0,0,0,0c-12.8,8.4-7.1,23.5-6.2,25.6 c0,0,0,0,0,0c0.1,0.1,0.1,0.2,0.1,0.2c0.3,0.7,0.5,1,1.2-0.2c0,0,2.6-3.3,6-3.6C86.6,104.8,85.1,103.2,84,100.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M112,136.4c-1.5-4.9,0-10.2,3.3-14c0.1-0.1,0.2-0.2,0.3-0.3c2.9-3,11.3-9.5,5.3-12.8c-7.9-4.3-7,4-17.2,3.1 s-21.7-10-23.8,0.7c-2,10.6,11,16.4,12.6,18.9c0.7,1,18.8,46,22.2,54.3l14.4-4.1l-16.8-44.8C112.2,137.1,112.1,136.7,112,136.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.9,134.5c0,0-0.8-5.5,0.1-8.9c0,0,0,0,0,0c0.4-1.2,0.9-2.8,1.4-5.2c2.9-11.8-3.3-12-3.9-9l0,0 c0,0.1,0,0.2,0,0.3c0.1,3.9-7,10.9-8,11.8c-1.1,1-2,2.2-2.7,3.6c-0.3,0.7-0.6,1.4-0.7,2c-0.6,3,1.9,3.5,5.4,7.9 c2.7,3.4,11,31,14.6,43.2l8.5-2.4C140.9,167.4,132.8,144.3,129.9,134.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalciumDeficiency);
export default __webpack_public_path__ + "static/media/Calcium_Deficiency.634d324480397c8d5204e765cf443f61.svg";
export { ForwardRef as ReactComponent };